import { EXTENSIONS_ACTION } from '../../constants/actions'

const changeToolsFilterState = (value) => {
  return {
    type: EXTENSIONS_ACTION.CHANGE_TOOL_FILTER_STATE,
    payload: {
      value
    }
  }
}

export { changeToolsFilterState }
